// extracted by mini-css-extract-plugin
export default {"container":"masterDataSettingAdminPage_container__T+fw7","mainContainer":"masterDataSettingAdminPage_mainContainer__EOnDA"};